/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Error_UploadInputs */



/**
* | output |
* | --- |
* | "Upload failed." |
*
* @param {Deck_Error_UploadInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_error_upload = /** @type {((inputs?: Deck_Error_UploadInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Error_UploadInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec du téléchargement.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al cargar.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha no envio.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento fallito.")
	return /** @type {LocalizedString} */ ("Upload failed.")
});